import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container index" },
    [
      _c(VSubheader, [_vm._v("Stored Data")]),
      _c("div", { staticClass: "ma-5" }, [
        _vm.storedData
          ? _c("pre", [_vm._v(_vm._s(_vm.storedData))])
          : _c("span", [_vm._v("No Data")]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }